/**
 * Tip i18n
 */

import type { TranslationDict } from '../types'

export const tip: TranslationDict = {
  // Buttons
  tipButton: { en: 'Tip', 'zh-CN': '打赏', ja: '投げ銭' },
  tipPost: { en: 'Tip author', 'zh-CN': '打赏作者', ja: '作者を支援' },
  subscribe: { en: 'Subscribe', 'zh-CN': '订阅', ja: 'サブスク' },
  manageSubscription: { en: 'Subscribed', 'zh-CN': '已订阅', ja: 'サブスク中' },

  // Modal
  title: { en: 'Send a tip', 'zh-CN': '发送打赏', ja: '投げ銭を送る' },
  titleWithName: {
    en: 'Tip {{name}}',
    'zh-CN': '打赏 {{name}}',
    ja: '{{name}} に投げ銭',
  },
  customAmount: { en: 'Custom amount', 'zh-CN': '自定义金额', ja: 'カスタム金額' },
  submit: {
    en: 'Send {{amount}} SQR',
    'zh-CN': '发送 {{amount}} SQR',
    ja: '{{amount}} SQR を送信',
  },

  // Toast / states
  success: {
    en: 'Tipped {{amount}} SQR — thank you!',
    'zh-CN': '已打赏 {{amount}} SQR，谢谢支持！',
    ja: '{{amount}} SQR を送信しました。ありがとう！',
  },

  presetGroupLabel: {
    en: 'Preset tip amounts',
    'zh-CN': '预设金额',
    ja: '定額プリセット',
  },

  error: {
    insufficientBalance: {
      en: 'Insufficient SQR balance',
      'zh-CN': 'SQR 余额不足',
      ja: 'SQR 残高が不足しています',
    },
    invalidAmount: {
      en: 'Please enter a valid amount',
      'zh-CN': '请输入有效金额',
      ja: '有効な金額を入力してください',
    },
    notFound: {
      en: 'Recipient not available',
      'zh-CN': '接收方不可用',
      ja: '受取人を確認できません',
    },
    tooLarge: {
      en: 'Maximum {{max}} SQR per tip',
      'zh-CN': '单次最多 {{max}} SQR',
      ja: '1回最大 {{max}} SQR',
    },
    generic: {
      en: 'Tip failed, please retry',
      'zh-CN': '打赏失败，请重试',
      ja: '送信に失敗しました。再試行してください',
    },
  },
}
